// extracted by mini-css-extract-plugin
export default {"contestTabs":"ContestTabs_contestTabs__tDTMS"};